import { CheckCircleIcon } from "@heroicons/react/24/outline";

export const NvReportedTag = () => (
  <span className="inline-flex items-center gap-x-1 rounded-md bg-green-50 px-2 py-1.5 text-base font-medium text-green-900 ring-1 ring-inset ring-green-400/10">
    <CheckCircleIcon className="group relative -ml-1 h-3.5 sm:h-4 w-auto rounded-sm hover:bg-green-600/20 text-green-600" />
    Rapporterad
  </span>
);
